const LoadingLine = () => {
    return (
        <div className="mt-4">
            <span className="block h-8 w-8 border-l-2 border-dashed border-gray-300 mx-auto animate-bounce" />
        </div>
    )
}

export default LoadingLine